var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-draw-polygon",style:({ width: _vm.size.width + 'px', height: _vm.size.height + 'px' })},[_c('canvas',{staticClass:"video-draw-canvas",attrs:{"id":"videoCanvas","width":_vm.size.width,"height":_vm.size.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }